<template>
  <b-sidebar v-model="shown" id="sidebar-no-header" aria-labelledby="sidebar-no-header-title" right no-header width="35%">
    <template #default="{ hide }">
      <div class="px-3 py-4">
        <h4 id="sidebar-no-header-title">{{ $t('Conferência') }}</h4>
        <br />
        <b>Canal:</b> {{ getAppNameByClientID(canal) }}<br />
        <b>Original ID:</b> {{ id }}<br />
        <br />
        <b-row>
          <b-col cols="6">
            <label><b>Informe o SKU ou EAN:</b></label>
            <b-form-input ref="skuInput" id="skuInput" type="text" v-model="conferido" size="sm" autofocus></b-form-input>
          </b-col>
        </b-row>
        <br />
        <div v-for="(it, i) in a_confferir" :key="i">
          <b-row>
            <b-col cols="3">
              <b-img v-bind="mainProps" :src="it.photo_url"></b-img>
            </b-col>
            <b-col>
              <font size="3"><b>Nome:</b> {{ it.name }} </font>
              <br />
              <font size="3"><b>Sku:</b> {{ it.sku }} </font>
              <br />
              <div v-if="it.variation && it.variation.sku">
                <font size="3"><b>Variação:</b> {{ it.variation.sku }} </font>
                <br />
              </div>
              <font size="3"><b>Conferidos:</b> {{ it.total_checked }}/{{ it.quantity }} </font>
              &nbsp;
              <font size="4" v-if="it.conferido">
                <i class="btn-edit fa fa-check text-green"></i>
              </font>
            </b-col>
          </b-row>
        </div>
        <b-button variant="success" size="sm" block @click="next()" :disabled="buttonNextDesabled">
          Próximo
        </b-button>
        <b-button variant="primary" size="sm" block @click="clear()">
          Fechar
        </b-button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import barramento from "../../../../barramento";
import swal from "sweetalert2";

export default {
  name: "SidebarPicking",
  props: ["expedition", "apps"],
  data() {
    return {
      id: null,
      index: null,
      canal: null,
      shown: false,
      items: [],
      obj: null,
      a_confferir: [],
      conferido: null,
      total_checked: 0,
      buttonNextDesabled: true,
      mainProps: { width: 150, height: 150 },
      find_product: false
    };
  },
  watch: {
    conferido: {
      handler(newValue, oldValue) {
        if (!newValue) {
          this.skuInputFocus();
          return;
        }

        this.find_product = false;
        for (let i in this.a_confferir) {
          const item = this.a_confferir[i];
          const match =
            item.sku === newValue ||
            (!!item.variation && !!item.variation.sku && item.variation.sku === newValue || item.variation.ean === newValue) ||
            item.ean === newValue;

          // Só incrementa se ainda não atingiu a quantidade
          if (match && item.total_checked < item.quantity) {
            item.total_checked += 1;
            this.find_product = true;

            // Marca como conferido se atingiu a quantidade
            if (item.total_checked >= item.quantity) {
              item.conferido = true;
            }
            break; // Só marca um item por bipagem
          }
        }

        setTimeout(() => {
          this.conferido = '';
        }, 1000);

        setTimeout(() => {
          if (this.find_product === false) {
            swal({
              title: "Atenção!",
              text: this.$t("Produto não localizado no pedido."),
              type: "warning",
            }).then(() => {
              this.conferido = '';
            });
          }
        }, 1000);

        this.valida();
        this.focusOnSkuInput();
      },
      deep: true,
    },
  },
  methods: {
    getAppNameByClientID(clientID) {
      if (
        clientID == "6e19e8b91aa41d1911cf24ef4ae265e7" ||
        clientID == "NTJhYTI3MTc4MDYyZjNk"
      ) {
        return "Painel de Pedidos";
      }
      for (var i in this.apps) {
        if (this.apps[i].client_id == clientID) {
          return this.apps[i].name;
        }
      }
      return clientID;
    },
    next() {
      barramento.$emit(
        `expedition_sidebar_picking_next_${this.expedition}`,
        this.index
      );

      this.impressao();

      this.conferido = null;
      this.total_checked = 0

      this.nextHttp(this.id);
    },
    clear() {
      barramento.$emit(
        `expedition_sidebar_picking_clear_${this.expedition}`,
        this.index
      );
      this.shown = false;
    },
    valida() {
      this.buttonNextDesabled = false;
      for (var i in this.a_confferir)
      {
        if (this.a_confferir[i].conferido == false)
        {
          this.buttonNextDesabled = true;
        }
      }

      if(this.buttonNextDesabled === false)
      {
          this.next()
      }
          
    },
    setAconferir() {
      if (this.expedition == 'pronto_para_embalar') {
        this.a_confferir = this.items.reduce((product, item) => {
          item.ean = (typeof item.ean !== 'undefined') ? item.ean : null
          var key = (item.ean !== null) ? item.ean : item.sku
          if (!product[key]) {
            product[key] = {
              id: this.uniqid(),
              photo_url: item.photo_url,
              name: item.name,
              sku: item.sku,
              variation: item.variation,
              ean: item.ean,
              quantity: 0,
              conferido: false,
              total_checked: 0
            }
          }
          product[key].quantity += item.quantity
          return product;
        }, {});
      }
    },
    uniqid(prefix = "", random = false) {
      const sec = Date.now() * 1000 + Math.random() * 1000;
      const id = sec.toString(16).replace(/\./g, "").padEnd(14, "0");
      return prefix + id + random ? Math.trunc(Math.random() * 100000000) : "";
    },
    impressao() {

      swal({
                title: "Aguarde!",
                text: this.$t(
                  "Estamos gerando os arquivos para impressão..."
                ),
                showConfirmButton: false,
                onOpen: ()=>{
                    swal.showLoading();
                }
              });
      var need_print = false
      const data = []
      const id = this.obj.id

      this.obj.shipments.forEach(function(shipment){
        shipment.documents.forEach(function(document){
              if(document.type == 'label' || 
              document.type == 'invoice' ||
              document.type == 'invoice_label')
              {
                need_print = true
                if (!data.find((item) =>
                  item.type === document.type &&
                  (document.type !== 'label' || item.url === document.url))) {
                  data.push({
                    id: id,
                    type: document.type,
                    url: document.url
                  })
                }
              }
          })
      })


      if(need_print)
      {
        this.$http.post("api/orders/mergePdfs", data)
        .then((response) => {
          window.open(response.data.file, "impressão", "height=700,width=700");
          swal.close()
          need_print = false
        })
        .catch((error) => {
        })
      }else{
        swal({
            title: "Atenção!",
            text: this.$t(
              "Não há etiqueta ou nota fiscal para imprimir."
            ),
            type: "warning",
          });
      }
    },
    nextHttp(id) {
      this.$http
        .post("/api/orders/updatestatus", [
          {
            id: id,
            status: "shipping_informed",
            sub_status: "processing_expedition",
          },
        ])
        .then(
          (response) => {
          },
          (error) => {
            swal({
              title: "Ops!",
              text: `Não foi possível moder de status o pedido ${id}`,
              type: "error",
            });
          }
        );
    },
    ffocus() {
      setTimeout(() => {
        this.conferido = null;
        this.skuInputFocus()
      }, 1000);
    },
    focusOnSkuInput() {
      setTimeout(() => {
        this.skuInputFocus()
      }, 300);
    },
    skuInputFocus() {
      this.$refs.skuInput.$el.focus();
    }
  },
  beforeDestroy() {
    barramento.$off(`siderbar_picking_expedition_${this.expedition}`);
    barramento.$off(`siderbar_picking_expedition_hide_${this.expedition}`);
  },
  created() {
    barramento.$on(
      `siderbar_picking_expedition_hide_${this.expedition}`,
      () => {
        this.conferido = null;
        this.total_checked = 0
        this.a_confferir = [];
        this.buttonNextDesabled = true;
        this.shown = false;
      }
    );
    barramento.$on(`siderbar_picking_expedition_${this.expedition}`, (obj) => {
      this.conferido = null;
      this.total_checked = 0;
      this.a_confferir = [];
      this.id = obj.id;
      this.items = obj.items;
      this.obj = obj.obj;
      this.index = obj.index;
      this.canal = obj.created_by;
      this.setAconferir();
      this.shown = true;
      this.buttonNextDesabled = true;
      this.ffocus();
      this.focusOnSkuInput()
    });
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Expeditions_v2/Aggregates/Sidebar/SidebarPicking.vue